<template>
  <div>
    <main>
      <div class="videoSolo" v-if="message">
        <h1>{{message}}</h1>
        <div class="alignCenter">
          <router-link v-if="hideBtn" :to="`/video?id=${videoId}`" class="button">Got to the video entry</router-link>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { api } from '@/config'
import axios from 'axios'

export default {
  name: 'Video',
  data() {
    return {
      message: '',
      videoId: '',
      hideBtn: false
    }
  },
  mounted() {
    document.querySelector('body').style.background = '#2d2d2d'
    if (this.$route.query.code) {
      axios.post(api.vote, {
        code: this.$route.query.code
      }).then(response => {
        if (response.data.status === 'success') {
          this.videoId = response.data.submissionId
          this.message = 'You vote is now confirmed.'
        } else {
          this.message = response.data.errors[0]
        }
      }).catch(err => {
        console.log(err)
        this.hideBtn = true
        this.message = 'Link invalid or vote was already applied.'
      })
    } else {
      this.message = 'Link is invalid.'
      this.hideBtn = true
    }
  },
  beforeDestroy() {
    document.querySelector('body').style.background = '#fff'
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.videoSolo {
  text-align: center;
}
</style>
